import { servicePayments } from "../servicePayments";
import {
  IPayeeEngagementResponse,
  IPayeeEngagementUpdateRequest
} from "@wingspanhq/payments/dist/interfaces/api/payerPayeeEngagement";
import { extendConfigWithXWingspanUserHeader } from "../../shared/utils/extendHeadersWithXWingspanUser";

export const updatePayeeEngagementByPayeeId = async (
  payeeId: string,
  engagementId: string,
  request: IPayeeEngagementUpdateRequest,
  orgPayerId: string | undefined
): Promise<IPayeeEngagementResponse> => {
  const { data } = await servicePayments.patch(
    `/payee/${payeeId}/engagement/${engagementId}`,
    request,
    extendConfigWithXWingspanUserHeader({}, orgPayerId)
  );

  return data;
};
